export default ({ typography }) => ({
  close: {
    '& svg': {
      height: 24,
      width: 24
    },
    right: 18,
    top: 20
  },
  dialogBody: {
    paddingTop: 20
  },
  dialogHeader: {
    paddingBottom: 0
  },
  dialogRoot: {
    boxShadow: '0px 0px 20px rgba(0,0,0,0.2)',
    margin: [30, 'auto'],
    maxWidth: ({ maxWidth }) => maxWidth,
    minWidth: ({ minWidth }) => minWidth
  },
  footer: {},
  header: {
    '& h1': {
      ...typography.h1
    }
  },
  root: {
    bottom: 0,
    left: ({ initialPosition }) => initialPosition.x || 0,
    position: 'fixed',
    right: 0,
    top: ({ initialPosition }) => initialPosition.y || 0,
    zIndex: 1000
  }
});
